import { CLIENT_CAPABILITIES } from "./clientCapabilities";

// Create a proxy object that always gets the latest values from localStorage
const createFeaturesProxy = () => {
  const handler = {
    get: function(target, prop) {
      // Get the current client from localStorage each time a property is accessed
      const currentClient = localStorage.getItem('clientIdentityName') || "default";
      
      // 1. Get the specific client settings (or empty object if not found)
      const clientSpecific = CLIENT_CAPABILITIES[currentClient] || {};
      
      // 2. Merge: Start with defaults, then overwrite with client specific settings
      const capabilities = {
        ...CLIENT_CAPABILITIES.default,
        ...clientSpecific
      };
      
      // Return the requested property
      return capabilities[prop];
    }
  };

  return new Proxy({}, handler);
};

// Export a single instance of the proxy
export const FEATURES = createFeaturesProxy();